import { shuffled, type RandomSource } from "../domain/presentationOrder";

const answerGroupSelector = [
  ".choice-grid",
  ".yes-no-controls",
  ".activity-choices",
  ".benefit-choices",
  ".bone-tray",
  ".bone-slots",
  ".growth-sequence",
].join(", ");

export function shuffleAnswerPresentation(
  root: ParentNode,
  random: RandomSource = Math.random,
): void {
  for (const select of root.querySelectorAll<HTMLSelectElement>("select")) {
    const options = [...select.options];
    if (options[0]?.value === "") options.shift();
    for (const option of shuffled(options, random)) select.append(option);
  }

  for (const group of root.querySelectorAll<HTMLElement>(answerGroupSelector)) {
    for (const child of shuffled([...group.children], random))
      group.append(child);
  }
}
